/**
 * Model inicjalizacyjny (Bootstrap DTO) dostarczający absolutne minimum danych
 * wymaganych do uruchomienia i wyrenderowania początkowych ekranów aplikacji
 * pacjenta (np. ekranu ładowania, logowania i wizytówki).
 */
export class VetClinicStartContextData {

  /** Wewnętrzny, numeryczny kod ID kliniki. */
  public vetcodeId: number;

  /** Główna nazwa placówki wyświetlana w nagłówkach i powitaniach. */
  public clinicName: string;

  /** Oficjalny numer telefonu do recepcji. */
  public clinicPhone: string;

  /** Adres e-mail placówki do bezpośredniego kontaktu. */
  public clinicMail: string;

  /** Sformatowany, pełny adres fizyczny kliniki. */
  public clinicAddress: string;

  /** Długość geograficzna (Longitude). */
  public clinicLongitude: number;

  /** Szerokość geograficzna (Latitude). */
  public clinicLatitude: number;

  /** Obraz tła dla ekranu powitalnego (Splash Screen).
   */
  public splashScreenBackgroundImage: any;

  /** Obraz tła dla ekranu rejestracji / logowania.
   */
  public signupScreenBackgroundImage: any;

  /** Flaga określająca, czy w tej klinice włączona jest obsługa płatności online.
   */
  public paymentsEnabled: boolean;

  /** Skrót kryptograficzny (Hash) obecnego stanu konfiguracji startowej.
   */
  public hash: string;

  constructor() {
  }
}
